import styled from 'styled-components';

export const Container = styled.div`
    //position: relative;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    //min-height : 314.8px;
    //max-height : 314.8px;
    box-sizing : border-box;
    margin: 0 auto auto auto;
}
`;
export const Div = styled.div`
  display : flex;
  flex-direction : ${props => props.column ? "column" : "row"};
  margin : ${props => props.margin ? props.marin : "0"};
  justify-content : ${props => props.justifyContent ? props.justifyContent : "space-between"};
  align-items : center;
  height : 100%;
  width : 215px;
  margin : auto;
  word-break : keep-all;
`;

export const CommentContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 90%;
    //height: calc(100% - 54.53px);
    min-height: 100px;
    margin: 2px auto 55px auto;
    overflow: auto;

    ::-webkit-scrollbar{
        display: none;
        width: 10px; 
    }
    ::-webkit-scrollbar-track{
        display: none;
        background-color: #eee; 
        opacity: .3;
    }
    ::-webkit-scrollbar-thumb{
        display: none;
        background-color: rgb(199, 199, 199); 
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb:hover{
        display: none;
        background: rgb(117, 117, 117)
    }
    ::-webkit-scrollbar-button:start:decrement,::-webkit-scrollbar-button:end:increment {
        display: none;
        width : 10px; 
         height: 10px; 
        background:#eee;
    }
`

export const InputContainer = styled.div`
    width: 100%;
    position: absolute;
    bottom: 0;
`